import PropTypes from 'prop-types';
import React from 'react';
import { formatPrice } from '../../../helpers/currency';

const VipPreButtonMessage = ({
  currencySymbol,
  discount,
  discountPercentage,
  isFreeSubTrial,
  isModernVip,
  months,
  timeUnit = '',
  vipOptInBasketDiscount,
  vipOptInType = '',
}) => {
  const displayDiscount = formatPrice(discount, true);
  const monthOrMonths = months === 1 ? 'month' : 'months';
  const timeUnitText = months === 1 ? `${timeUnit}` : `${timeUnit}S`;

  if (typeof discount !== 'number' || typeof months !== 'number') return null;

  if (
    vipOptInType?.includes('VIP-SUB-FREE-TRIAL') &&
    isModernVip &&
    vipOptInBasketDiscount > 0
  ) {
    return (
      <div className="message-vip">
        Enjoy 1 Month of{' '}
        <span className="primary">
          {' '}
          <span className="primary">VIP MEMBERSHIP</span>
        </span>{' '}
        for <span className="primary">FREE</span>
        <div className="discount-message">
          <br /> Save an extra{' '}
          <span className="bold">
            {currencySymbol}
            {vipOptInBasketDiscount?.toFixed(2)}
          </span>{' '}
          right now with an exclusive discount of up to{' '}
          <span className="primary">{discountPercentage}%</span>
        </div>
        <style jsx>{`
          .bold {
            font-weight: 700;
          }
          .discount-message {
            font-size: 14px;
            font-weight: 400;
          }
          .message-vip {
            line-height: 1;
          }
          .vip-logo {
            max-width: 50px;
          }
        `}</style>
      </div>
    );
  }

  return (
    <>
      <div>
        Enjoy{' '}
        <span className="primary text-capitalise">
          {`${months} ${timeUnitText || monthOrMonths}`}
        </span>{' '}
        of <span className="primary">VIP MEMBERSHIP</span>{' '}
        {isFreeSubTrial && (
          <>
            for <span className="primary">FREE</span>
          </>
        )}
        <br /> and receive a discount of{' '}
        <span className="primary">
          {currencySymbol}
          {displayDiscount}
        </span>
      </div>
      <style jsx>
        {`
          .text-uppercase {
            text-transform: capitalize;
          }
        `}
      </style>
    </>
  );
};

VipPreButtonMessage.propTypes = {
  currencySymbol: PropTypes.string,
  discount: PropTypes.number,
  discountPercentage: PropTypes.number,
  isFreeSubTrial: PropTypes.bool,
  isModernVip: PropTypes.bool,
  months: PropTypes.number,
  vipOptInBasketDiscount: PropTypes.number,
  vipOptInType: PropTypes.string,
};

export default VipPreButtonMessage;
